// store.js
// import { createStore, applyMiddleware, compose } from 'redux';
// import singleReducer from './reducers/index';
// import thunk from 'redux-thunk';

// const store = createStore(
// 	singleReducer,
// 	compose (applyMiddleware(thunk),
// 		window.devToolsExtension? window.devToolsExtension(): f => {return f})
// );

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import siteReducer from "./siteSlice";
import chargerReducer from "./chargerSlice";
import vehicleReducer from "./vehicleSlice";
import ChargerTableReducer from "./chargerTableSlice";
import loaderReducer from "./loader";
// import { routerMiddleware, connectRouter } from 'connected-react-router';
// import { createBrowserHistory } from 'history';

export default configureStore({
  // middleware: [thunk, routerMiddleware(history)],
  reducer: {
    siteList: siteReducer,
    chargerList: chargerReducer,
    vehicleList: vehicleReducer,
    chargerTableList: ChargerTableReducer,
    loader: loaderReducer,
  },
});
